import React from 'react'
import ChargeStep from '../Payment/ChargeStep';
import useAxios from 'axios-hooks'
import {ContentContainer} from 'components/ContentContainer';
// import { getAuthHeader } from 'utils/auth'

const PaymentRequired = () => {

//   const [{ data: tiersData, loading: tiersLoading, error: tiersError }, getTiers] = useAxios(
//     {
//       method: 'GET',
//       url: `/payment/tiers`,
//       headers: getAuthHeader()
//     }
// )

  const [{ data: configData, loading: configLoading, error: condifgError }] = useAxios({
    url: '/payment/configuration',
    method: 'GET'
  })

  return (
    <ContentContainer>
      {configData && <ChargeStep stripePK={configData} />}
    </ContentContainer>
  )
}

export default PaymentRequired